import { CalendarShift, Job } from '@core/app/types/logworkApiType'
import { formatArrayForJobSelect } from '@core/utils/helpers/formatArrayForJobSelect'
import { filterJobsByConditions, getConditionsByTabType } from '@core/utils/helpers/jobConditions'

import { DayjsType } from '@page/logwork/logwork'
import { LogWorkTabType } from '@page/logwork/types/types'

export type FormattedJob = {
    value: string
    label: string
    sublabel?: string
    disabled?: boolean
    disabledWarning?: string | null
    isOpenedForDays: boolean[]
    availableTabs: LogWorkTabType[]
}

export type FormattedJobsByDay = {
    [dayIndex: number]: FormattedJob[]
}

/**
 * Calculate formatted jobs for a specific tab type
 */
export const calculateFormattedJobsForTab = (
    jobs: Job[],
    shifts: CalendarShift[],
    dates: { start: DayjsType; end: DayjsType },
    tabType: LogWorkTabType
): FormattedJobsByDay => {
    const jobsByDay: FormattedJobsByDay = {}
    const filteredJobsForTab = filterJobsByConditions(jobs, getConditionsByTabType(tabType))

    for (let i = 0; i < 7; i++) {
        jobsByDay[i] = formatArrayForJobSelect(filteredJobsForTab, dates, false, shifts, i, tabType)
    }

    return jobsByDay
}

/**
 * Calculate available jobs for a specific tab type
 */
export const calculateAvailableJobsForTab = (formattedJobs: FormattedJobsByDay): FormattedJobsByDay => {
    const availableByDay: FormattedJobsByDay = {}

    for (let i = 0; i < 7; i++) {
        availableByDay[i] = formattedJobs[i]?.filter((job) => !job.disabled) || []
    }

    return availableByDay
}
